export const OPEN_TAB = "OPEN_TAB"

export const GET_CUSTOMER_LIST_BEGIN = 'GET_CUSTOMER_LIST_BEGIN';
export const GET_CUSTOMER_LIST_SUCCESS = 'GET_CUSTOMER_LIST_SUCCESS';
export const GET_CUSTOMER_LIST_ERROR = 'GET_CUSTOMER_LIST_ERROR';

export const GET_DASHBOARD_SIDEBAR_LINKS_BEGIN = 'GET_DASHBOARD_SIDEBAR_LINKS_BEGIN';
export const GET_DASHBOARD_SIDEBAR_LINKS_SUCCESS = 'GET_DASHBOARD_SIDEBAR_LINKS_SUCCESS';
export const GET_DASHBOARD_SIDEBAR_LINKS_ERROR = 'GET_DASHBOARD_SIDEBAR_LINKS_ERROR';

export const GET_NOTES_BEGIN = 'GET_NOTES_BEGIN';
export const GET_NOTES_SUCCESS = 'GET_NOTES_SUCCESS';
export const GET_NOTES_ERROR = 'GET_NOTES_ERROR';

export const GET_FORM_VALUES = 'GET_FORM_VALUES';
export const RESET_FORM_VALUES = 'RESET_FORM_VALUES';



export const GET_VALUES_OF_REFFERED = 'GET_VALUES_OF_REFFERED';
export const GET_VALUES_OF_REFFERED_ADJUSTER_ID = 'GET_VALUES_OF_REFFERED_ADJUSTER_ID';

export const ADMIN_APROVED_IDS = 'ADMIN_APROVED_IDS';
export const GET_INSURENCE_COMPANIES = 'GET_INSURENCE_COMPANIES';
export const GET_SELECTED_PATIENT = 'GET_SELECTED_PATIENT';

export const FORM_VALIDATIONS_ERRORS = 'FORM_VALIDATIONS_ERRORS'
